export default {
  BandwidthUsageRanking: "Bandwidth Usage Ranking",
  BranchLinkQuality: "Branch Link Quality",
  GatewayExceptionTracking: "Gateway Exception Tracking",
  To: "To",
  _BandwidthUsageRanking: {
    UplinkBandwidthUsageRate: "Uplink Bandwidth Usage Rate%",
    DownlinkBandwidthUsageRate: "Downlink Bandwidth Usage Rate%",
    PeakUplinkBandwidth: "Peak Uplink Bandwidth",
    AverageUplinkBandwidth: "Average Uplink Bandwidth",
    PeakDownlinkBandwidth: "Peak Downlink Bandwidth",
    AverageDownlinkBandwidth: "Average Downlink Bandwidth",
    AllFlow: 'AllFlow',
  },
  _BranchLinkQuality: {
    BranchCPEHostName: "Branch CPE Host Name",
    HeadquartersCPEHostName: "Headquarters CPE Host Name",
    AverageLatency: "Average Latency ms(to headquarters)",
    AveragePacketLoss: "Average Packet Loss%（(to headquarters)",
    AverageJitterMs: "Average Jitter Msms（(to headquarters)",
    LinkQality: "Link Qality（(to headquarters)",
    ReferenceDelay: "Reference Delayms（(to headquarters)",
  },
  _GatewayExceptionTracking: {
    ServiceExceptionTime: 'Service Exception Time',
    ServiceRecoveryTime: 'Service Recovery Time',
    Duration: 'Duration',
  },
}
